import { DomainError } from "@econ-v1/rpc";
export function createStageContext(options) {
    return {
        app: {
            name: options.appName,
            version: options.version,
        },
        events: {
            publish: async (type, payload) => {
                await options.session.publish(type, payload);
            },
            subscribe: (type, listener) => options.session.subscribe(type, listener),
        },
        host: {
            navigate: options.navigate,
            root: options.root,
            uiApi: 1,
        },
        invokeCapability: async (capability, payload) => await options.session.invokeCapability(capability, payload),
        liveQuery: (name, params, listener) => options.session.liveQuery(name, params, listener),
        query: async (name, params) => await options.session.query(name, params),
        stage: {
            load: options.stageLoad ?? (async (_appName, _slot) => {
                throw new DomainError({
                    code: "stage_composition_not_enabled",
                    message: "Stage composition is not available for this host",
                });
            }),
        },
    };
}
//# sourceMappingURL=stage-context.js.map